import React, { useEffect } from 'react';
import apiService from '../../services/api';

/**
 * Home Page Component
 */
const HomePage = () => {
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await apiService.getAllProducts();
        console.log('Products response:', response);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();
  }, []);

  return (
    <div className="min-h-screen">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Welcome to Pharma Outlet</h1>
        <p className="text-gray-600">Your trusted pharmacy for all your health needs</p>
      </div>
    </div>
  );
};

export default HomePage;

